import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Axios instance with auth header
const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: async (username, password) => {
    const response = await axios.post(`${API_URL}/auth/login`, { username, password });
    return response.data;
  },
  logout: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
  },
  isAuthenticated: () => {
    return !!localStorage.getItem('admin_token');
  },
};

// Products API
export const productsAPI = {
  getAll: async () => {
    const response = await axios.get(`${API_URL}/products/`);
    return response.data;
  },
  getOne: async (id) => {
    const response = await axios.get(`${API_URL}/products/${id}`);
    return response.data;
  },
  create: async (formData) => {
    const response = await api.post(`${API_URL}/products/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  update: async (id, formData) => {
    const response = await api.put(`${API_URL}/products/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`${API_URL}/products/${id}`);
    return response.data;
  },
  addImages: async (id, images) => {
    const formData = new FormData();
    images.forEach((image) => {
      formData.append('images', image);
    });
    const response = await api.post(`${API_URL}/products/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  removeImage: async (id, imageUrl) => {
    const response = await api.delete(`${API_URL}/products/${id}/images`, {
      params: { image_url: imageUrl },
    });
    return response.data;
  },
};

// Settings API
export const settingsAPI = {
  get: async () => {
    const response = await axios.get(`${API_URL}/settings/`);
    return response.data;
  },
  update: async (formData) => {
    const response = await api.put(`${API_URL}/settings/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

// Contact API
export const contactAPI = {
  submit: async (data) => {
    const response = await axios.post(`${API_URL}/contact/`, data);
    return response.data;
  },
  getAll: async () => {
    const response = await api.get(`${API_URL}/contact/`);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`${API_URL}/contact/${id}`);
    return response.data;
  },
};
